/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm, pxToEmWithBaseline, replacePXinStringWithEM} from '@insticator/insticator-ui'; // iui-utils
import { buttonStyles, linkStyles, textStyles, themeV2 } from 'utils/themeV2';
import { url } from 'utils/urls';

const googleSignInBttnSrc = {
	normal: `${url.image}/btn_google_signin_light_normal_web.png`,
	focus: `${url.image}/btn_google_signin_light_focus_web.png`,
	pressed: `${url.image}/btn_google_signin_light_pressed_web.png`
};

function preloadImages(sources) {
    sources.forEach(source => {
        new Image().src = source;
    });
}

preloadImages(Object.values(googleSignInBttnSrc))

/* ++++++++++ --------------- EXPORT : AUTH SIGNIN STYLES --------------- ++++++++++ */
export default theme => ({
	signin: {
        ...textStyles,
        ...linkStyles,
		'& .form': {
            '& .ctas': {
                '& .cta': {
                    width: `${pxToEm(190)} !important`,
                    height: `${pxToEm(41.5)} !important`,
                    // marginBottom: `${pxToEm(2)} !important`
                    // margingTop: pxToEm(5),
                    margin: `${replacePXinStringWithEM(`5px 5px 2px 5px`)} !important`,
                    ...buttonStyles
                },
                '& .googlesignin': {
                    marginTop: pxToEm(4),
                    backgroundImage: `url(${googleSignInBttnSrc.normal})`,
                    backgroundColor: '#FFFFFF',
                    height: pxToEm(46),
					width: pxToEm(191),
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'contain',
                    cursor: 'pointer',
					'&.pressed-false': {
                        '&:hover': {
                            transition: 'background 0.25s linear 0s',
                            backgroundImage: `url(${googleSignInBttnSrc.focus})`,

                        },
					},
                    '&.pressed-true': {
                        transition: 'background 0.25s linear 0s',
                        backgroundImage: `url(${googleSignInBttnSrc.pressed})`,
                        cursor: 'default',
                        pointerEvents: 'none'
					}
                },
            },
            '& .divider': {
                marginBottom: `${pxToEm(5)} !important`
            },
			'& .grid': {
				'& .name-helpers': {
					justifyContent: 'space-between',
					alignItems: 'center',
					alignContent: 'center',
					'& .griditem': {
						minWidth: `${pxToEm(200)} !important`,
						width: 'auto',
						'& .field': {
							minWidth: `${pxToEm(200)} !important` // used to drop info or errormessage down beneath the form element and label
						}
					}
				}
			}
		}
	}
});
